import React from 'react'


export default class extends React.Component {

  render() {
    document.title = "INFLOW Online Marketing Bluesky - Peter van der Meer - Helpt jouw bedrijf groeien.";
    
    var headTag = document.getElementsByTagName('head')[0];
    var charsetTag = document.createElement('meta');
    charsetTag.setAttribute("http-equiv", "refresh");
    charsetTag.setAttribute("content", "0; URL='https://bsky.app/profile/peter-inflow.bsky.social'");
    headTag.appendChild(charsetTag);

    return (
      <div style={{margin:"3em"}}>Je wordt doorgestuurd naar <a href="https://bsky.app/profile/peter-inflow.bsky.social">bsky.app/profile/peter-inflow.bsky.social</a></div>
      );
  }

}



// WEBPACK FOOTER //
// ./src/containers/redir_bs.js